module.exports = __webpack_public_path__ + "static/media/4.99acef1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/slides/4.png
// module id = 253
// module chunks = 0